// tslint:disable
// this is an auto generated file. This will be overwritten

export const createTask = `mutation CreateTask($input: CreateTaskInput!) {
  createTask(input: $input) {
    id
    title
    description
    status
    assignedTo {
      id
      dateOfBirth
      name
      surname
      emailAddress
      contactNumber
      idNumber
      physicalAddress
      archived
      verified
      role
      status
      jobTitle
      company {
        nextToken
      }
      companyTeamLead {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const updateTask = `mutation UpdateTask($input: UpdateTaskInput!) {
  updateTask(input: $input) {
    id
    title
    description
    status
    assignedTo {
      id
      dateOfBirth
      name
      surname
      emailAddress
      contactNumber
      idNumber
      physicalAddress
      archived
      verified
      role
      status
      jobTitle
      company {
        nextToken
      }
      companyTeamLead {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const deleteTask = `mutation DeleteTask($input: DeleteTaskInput!) {
  deleteTask(input: $input) {
    id
    title
    description
    status
    assignedTo {
      id
      dateOfBirth
      name
      surname
      emailAddress
      contactNumber
      idNumber
      physicalAddress
      archived
      verified
      role
      status
      jobTitle
      company {
        nextToken
      }
      companyTeamLead {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const createCompany = `mutation CreateCompany($input: CreateCompanyInput!) {
  createCompany(input: $input) {
    id
    createdAt
    name
    emailAddress
    contactNumber
    address
    province
    industry
    physicalAddress
    numberOfEmployees
    archived
    interests {
      items {
        id
      }
      nextToken
    }
    suburb
    teamLead {
      id
      dateOfBirth
      name
      surname
      emailAddress
      contactNumber
      idNumber
      physicalAddress
      archived
      verified
      role
      status
      jobTitle
      company {
        nextToken
      }
      companyTeamLead {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
    teamMembers {
      items {
        id
      }
      nextToken
    }
    reports {
      items {
        id
      }
      nextToken
    }
    transactions {
      id
      card {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
      report {
        id
        name
        description
        publisedDate
        price
        documentLocation
        maxDownloads
        downloadable
        status
        province
        suburb
        city
        paidOrFree
        reportDetails
        coverImageUrl
        documentResourceUrl
      }
      company {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const updateCompany = `mutation UpdateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    id
    createdAt
    name
    emailAddress
    contactNumber
    address
    province
    industry
    physicalAddress
    numberOfEmployees
    archived
    interests {
      items {
        id
      }
      nextToken
    }
    suburb
    teamLead {
      id
      dateOfBirth
      name
      surname
      emailAddress
      contactNumber
      idNumber
      physicalAddress
      archived
      verified
      role
      status
      jobTitle
      company {
        nextToken
      }
      companyTeamLead {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
    teamMembers {
      items {
        id
      }
      nextToken
    }
    reports {
      items {
        id
      }
      nextToken
    }
    transactions {
      id
      card {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
      report {
        id
        name
        description
        publisedDate
        price
        documentLocation
        maxDownloads
        downloadable
        status
        province
        suburb
        city
        paidOrFree
        reportDetails
        coverImageUrl
        documentResourceUrl
      }
      company {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const deleteCompany = `mutation DeleteCompany($input: DeleteCompanyInput!) {
  deleteCompany(input: $input) {
    id
    createdAt
    name
    emailAddress
    contactNumber
    address
    province
    industry
    physicalAddress
    numberOfEmployees
    archived
    interests {
      items {
        id
      }
      nextToken
    }
    suburb
    teamLead {
      id
      dateOfBirth
      name
      surname
      emailAddress
      contactNumber
      idNumber
      physicalAddress
      archived
      verified
      role
      status
      jobTitle
      company {
        nextToken
      }
      companyTeamLead {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
    teamMembers {
      items {
        id
      }
      nextToken
    }
    reports {
      items {
        id
      }
      nextToken
    }
    transactions {
      id
      card {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
      report {
        id
        name
        description
        publisedDate
        price
        documentLocation
        maxDownloads
        downloadable
        status
        province
        suburb
        city
        paidOrFree
        reportDetails
        coverImageUrl
        documentResourceUrl
      }
      company {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const createUser = `mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
    dateOfBirth
    name
    surname
    emailAddress
    contactNumber
    idNumber
    physicalAddress
    archived
    verified
    role
    status
    jobTitle
    company {
      items {
        id
      }
      nextToken
    }
    companyTeamLead {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const updateUser = `mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    dateOfBirth
    name
    surname
    emailAddress
    contactNumber
    idNumber
    physicalAddress
    archived
    verified
    role
    status
    jobTitle
    company {
      items {
        id
      }
      nextToken
    }
    companyTeamLead {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const deleteUser = `mutation DeleteUser($input: DeleteUserInput!) {
  deleteUser(input: $input) {
    id
    dateOfBirth
    name
    surname
    emailAddress
    contactNumber
    idNumber
    physicalAddress
    archived
    verified
    role
    status
    jobTitle
    company {
      items {
        id
      }
      nextToken
    }
    companyTeamLead {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const createReport = `mutation CreateReport($input: CreateReportInput!) {
  createReport(input: $input) {
    id
    name
    description
    publisedDate
    price
    documentLocation
    maxDownloads
    downloadable
    status
    province
    suburb
    city
    paidOrFree
    reportDetails
    coverImageUrl
    documentResourceUrl
    tags {
      items {
        id
      }
      nextToken
    }
    categories {
      items {
        id
      }
      nextToken
    }
    reigon {
      items {
        id
      }
      nextToken
    }
    companys {
      items {
        id
      }
      nextToken
    }
    vouchers {
      items {
        id
      }
      nextToken
    }
    transactions {
      id
      card {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
      report {
        id
        name
        description
        publisedDate
        price
        documentLocation
        maxDownloads
        downloadable
        status
        province
        suburb
        city
        paidOrFree
        reportDetails
        coverImageUrl
        documentResourceUrl
      }
      company {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const updateReport = `mutation UpdateReport($input: UpdateReportInput!) {
  updateReport(input: $input) {
    id
    name
    description
    publisedDate
    price
    documentLocation
    maxDownloads
    downloadable
    status
    province
    suburb
    city
    paidOrFree
    reportDetails
    coverImageUrl
    documentResourceUrl
    tags {
      items {
        id
      }
      nextToken
    }
    categories {
      items {
        id
      }
      nextToken
    }
    reigon {
      items {
        id
      }
      nextToken
    }
    companys {
      items {
        id
      }
      nextToken
    }
    vouchers {
      items {
        id
      }
      nextToken
    }
    transactions {
      id
      card {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
      report {
        id
        name
        description
        publisedDate
        price
        documentLocation
        maxDownloads
        downloadable
        status
        province
        suburb
        city
        paidOrFree
        reportDetails
        coverImageUrl
        documentResourceUrl
      }
      company {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const deleteReport = `mutation DeleteReport($input: DeleteReportInput!) {
  deleteReport(input: $input) {
    id
    name
    description
    publisedDate
    price
    documentLocation
    maxDownloads
    downloadable
    status
    province
    suburb
    city
    paidOrFree
    reportDetails
    coverImageUrl
    documentResourceUrl
    tags {
      items {
        id
      }
      nextToken
    }
    categories {
      items {
        id
      }
      nextToken
    }
    reigon {
      items {
        id
      }
      nextToken
    }
    companys {
      items {
        id
      }
      nextToken
    }
    vouchers {
      items {
        id
      }
      nextToken
    }
    transactions {
      id
      card {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
      report {
        id
        name
        description
        publisedDate
        price
        documentLocation
        maxDownloads
        downloadable
        status
        province
        suburb
        city
        paidOrFree
        reportDetails
        coverImageUrl
        documentResourceUrl
      }
      company {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const createReigon = `mutation CreateReigon($input: CreateReigonInput!) {
  createReigon(input: $input) {
    id
    name
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const updateReigon = `mutation UpdateReigon($input: UpdateReigonInput!) {
  updateReigon(input: $input) {
    id
    name
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const deleteReigon = `mutation DeleteReigon($input: DeleteReigonInput!) {
  deleteReigon(input: $input) {
    id
    name
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const createTag = `mutation CreateTag($input: CreateTagInput!) {
  createTag(input: $input) {
    id
    name
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const updateTag = `mutation UpdateTag($input: UpdateTagInput!) {
  updateTag(input: $input) {
    id
    name
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const deleteTag = `mutation DeleteTag($input: DeleteTagInput!) {
  deleteTag(input: $input) {
    id
    name
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const createCategory = `mutation CreateCategory($input: CreateCategoryInput!) {
  createCategory(input: $input) {
    id
    name
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const updateCategory = `mutation UpdateCategory($input: UpdateCategoryInput!) {
  updateCategory(input: $input) {
    id
    name
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const deleteCategory = `mutation DeleteCategory($input: DeleteCategoryInput!) {
  deleteCategory(input: $input) {
    id
    name
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const createVoucher = `mutation CreateVoucher($input: CreateVoucherInput!) {
  createVoucher(input: $input) {
    id
    name
    code
    discountPercentage
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const updateVoucher = `mutation UpdateVoucher($input: UpdateVoucherInput!) {
  updateVoucher(input: $input) {
    id
    name
    code
    discountPercentage
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const deleteVoucher = `mutation DeleteVoucher($input: DeleteVoucherInput!) {
  deleteVoucher(input: $input) {
    id
    name
    code
    discountPercentage
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const createFaq = `mutation CreateFaq($input: CreateFaqInput!) {
  createFaq(input: $input) {
    id
    title
    question
    answer
    topic
    category
  }
}
`;
export const updateFaq = `mutation UpdateFaq($input: UpdateFaqInput!) {
  updateFaq(input: $input) {
    id
    title
    question
    answer
    topic
    category
  }
}
`;
export const deleteFaq = `mutation DeleteFaq($input: DeleteFaqInput!) {
  deleteFaq(input: $input) {
    id
    title
    question
    answer
    topic
    category
  }
}
`;
export const createInterest = `mutation CreateInterest($input: CreateInterestInput!) {
  createInterest(input: $input) {
    id
    name
    company {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const updateInterest = `mutation UpdateInterest($input: UpdateInterestInput!) {
  updateInterest(input: $input) {
    id
    name
    company {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const deleteInterest = `mutation DeleteInterest($input: DeleteInterestInput!) {
  deleteInterest(input: $input) {
    id
    name
    company {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const createTransaction = `mutation CreateTransaction($input: CreateTransactionInput!) {
  createTransaction(input: $input) {
    id
    card {
      id
      name
      type
      number
      nameOnCard
      expiryDate
      ccv
      purchases {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const updateTransaction = `mutation UpdateTransaction($input: UpdateTransactionInput!) {
  updateTransaction(input: $input) {
    id
    card {
      id
      name
      type
      number
      nameOnCard
      expiryDate
      ccv
      purchases {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const deleteTransaction = `mutation DeleteTransaction($input: DeleteTransactionInput!) {
  deleteTransaction(input: $input) {
    id
    card {
      id
      name
      type
      number
      nameOnCard
      expiryDate
      ccv
      purchases {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const createCard = `mutation CreateCard($input: CreateCardInput!) {
  createCard(input: $input) {
    id
    name
    type
    number
    nameOnCard
    expiryDate
    ccv
    purchases {
      id
      name
      type
      number
      nameOnCard
      expiryDate
      ccv
      purchases {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
    }
  }
}
`;
export const updateCard = `mutation UpdateCard($input: UpdateCardInput!) {
  updateCard(input: $input) {
    id
    name
    type
    number
    nameOnCard
    expiryDate
    ccv
    purchases {
      id
      name
      type
      number
      nameOnCard
      expiryDate
      ccv
      purchases {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
    }
  }
}
`;
export const deleteCard = `mutation DeleteCard($input: DeleteCardInput!) {
  deleteCard(input: $input) {
    id
    name
    type
    number
    nameOnCard
    expiryDate
    ccv
    purchases {
      id
      name
      type
      number
      nameOnCard
      expiryDate
      ccv
      purchases {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
    }
  }
}
`;
export const createCompanyInterest = `mutation CreateCompanyInterest($input: CreateCompanyInterestInput!) {
  createCompanyInterest(input: $input) {
    id
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
    interests {
      id
      name
      company {
        nextToken
      }
    }
  }
}
`;
export const updateCompanyInterest = `mutation UpdateCompanyInterest($input: UpdateCompanyInterestInput!) {
  updateCompanyInterest(input: $input) {
    id
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
    interests {
      id
      name
      company {
        nextToken
      }
    }
  }
}
`;
export const deleteCompanyInterest = `mutation DeleteCompanyInterest($input: DeleteCompanyInterestInput!) {
  deleteCompanyInterest(input: $input) {
    id
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
    interests {
      id
      name
      company {
        nextToken
      }
    }
  }
}
`;
export const createUserCompany = `mutation CreateUserCompany($input: CreateUserCompanyInput!) {
  createUserCompany(input: $input) {
    id
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
    user {
      id
      dateOfBirth
      name
      surname
      emailAddress
      contactNumber
      idNumber
      physicalAddress
      archived
      verified
      role
      status
      jobTitle
      company {
        nextToken
      }
      companyTeamLead {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const updateUserCompany = `mutation UpdateUserCompany($input: UpdateUserCompanyInput!) {
  updateUserCompany(input: $input) {
    id
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
    user {
      id
      dateOfBirth
      name
      surname
      emailAddress
      contactNumber
      idNumber
      physicalAddress
      archived
      verified
      role
      status
      jobTitle
      company {
        nextToken
      }
      companyTeamLead {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const deleteUserCompany = `mutation DeleteUserCompany($input: DeleteUserCompanyInput!) {
  deleteUserCompany(input: $input) {
    id
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
    user {
      id
      dateOfBirth
      name
      surname
      emailAddress
      contactNumber
      idNumber
      physicalAddress
      archived
      verified
      role
      status
      jobTitle
      company {
        nextToken
      }
      companyTeamLead {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const createCompanyReport = `mutation CreateCompanyReport($input: CreateCompanyReportInput!) {
  createCompanyReport(input: $input) {
    id
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const updateCompanyReport = `mutation UpdateCompanyReport($input: UpdateCompanyReportInput!) {
  updateCompanyReport(input: $input) {
    id
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const deleteCompanyReport = `mutation DeleteCompanyReport($input: DeleteCompanyReportInput!) {
  deleteCompanyReport(input: $input) {
    id
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const createReportTag = `mutation CreateReportTag($input: CreateReportTagInput!) {
  createReportTag(input: $input) {
    id
    tag {
      id
      name
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const updateReportTag = `mutation UpdateReportTag($input: UpdateReportTagInput!) {
  updateReportTag(input: $input) {
    id
    tag {
      id
      name
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const deleteReportTag = `mutation DeleteReportTag($input: DeleteReportTagInput!) {
  deleteReportTag(input: $input) {
    id
    tag {
      id
      name
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const createReportCategory = `mutation CreateReportCategory($input: CreateReportCategoryInput!) {
  createReportCategory(input: $input) {
    id
    category {
      id
      name
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const updateReportCategory = `mutation UpdateReportCategory($input: UpdateReportCategoryInput!) {
  updateReportCategory(input: $input) {
    id
    category {
      id
      name
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const deleteReportCategory = `mutation DeleteReportCategory($input: DeleteReportCategoryInput!) {
  deleteReportCategory(input: $input) {
    id
    category {
      id
      name
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const createReportReigon = `mutation CreateReportReigon($input: CreateReportReigonInput!) {
  createReportReigon(input: $input) {
    id
    reigon {
      id
      name
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const updateReportReigon = `mutation UpdateReportReigon($input: UpdateReportReigonInput!) {
  updateReportReigon(input: $input) {
    id
    reigon {
      id
      name
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const deleteReportReigon = `mutation DeleteReportReigon($input: DeleteReportReigonInput!) {
  deleteReportReigon(input: $input) {
    id
    reigon {
      id
      name
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const createReportVoucher = `mutation CreateReportVoucher($input: CreateReportVoucherInput!) {
  createReportVoucher(input: $input) {
    id
    voucher {
      id
      name
      code
      discountPercentage
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const updateReportVoucher = `mutation UpdateReportVoucher($input: UpdateReportVoucherInput!) {
  updateReportVoucher(input: $input) {
    id
    voucher {
      id
      name
      code
      discountPercentage
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const deleteReportVoucher = `mutation DeleteReportVoucher($input: DeleteReportVoucherInput!) {
  deleteReportVoucher(input: $input) {
    id
    voucher {
      id
      name
      code
      discountPercentage
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations.ts